// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: var(--ai-chat-keyboard-inset, 0px);
}

.chat-content {
  flex: 1 1 auto;
  min-height: 0;
  --padding-start: 12px;
  --padding-end: 12px;
  --padding-top: 12px;
  --padding-bottom: 12px;
}

.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px;
  animation: chatEmptyIn 0.4s ease-out;
}

.chat-empty__icon {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: #ed143d;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-empty__icon ion-icon {
  font-size: 28px;
  color: #fff;
}

.chat-empty__title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: break-spaces;
}

.chat-empty__subtitle {
  margin: 0 0 14px;
  max-width: 300px;
  font-size: 14px;
  line-height: 1.45;
  color: #666;
}

.chat-empty__hint {
  max-width: 300px;
  font-size: 13px;
  line-height: 1.4;
  color: #888;
}

.chat-empty__resume {
  -webkit-appearance: none;
          appearance: none;
  margin-top: 16px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ed143d;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.chat-empty__resume:active {
  opacity: 0.75;
}

.chat-empty__suggestions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 320px;
}

.chat-empty__chip {
  -webkit-appearance: none;
          appearance: none;
  width: 100%;
  padding: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  background: #fff;
  color: #333;
  font: inherit;
  font-size: 13px;
  line-height: 1.35;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
}
.chat-empty__chip:active {
  background: #fafafa;
  border-color: #ed143d;
  transform: scale(0.99);
}

@keyframes chatEmptyIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .chat-empty {
    animation: none;
  }
}
.message-row {
  display: flex;
  margin-bottom: 10px;
}
.message-row.user {
  justify-content: flex-end;
}
.message-row.user .bubble {
  background: #ed143d;
  color: white;
  border-radius: 16px 4px 16px 16px;
}
.message-row.assistant {
  justify-content: flex-start;
}
.message-row.assistant .bubble {
  background: #f0f0f0;
  color: #333;
  border-radius: 4px 16px 16px 16px;
}
.message-row.assistant .bubble:has(> *) {
  min-height: 40px;
}
.message-row.assistant .bubble:has(.chat-markdown) .thinking-text {
  display: none;
}
.message-row.assistant:not(:has(.bubble > *)) {
  display: none;
}

.message-row-inner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  max-width: 88%;
}

.message-row.user .message-row-inner {
  flex-direction: row-reverse;
}

ion-avatar.chat-message-avatar {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
}
ion-avatar.chat-message-avatar img {
  object-fit: cover;
}
ion-avatar.chat-message-avatar span {
  font-size: 11px;
  font-weight: 700;
  color: #ed143d;
  letter-spacing: 0.02em;
}

ion-avatar.chat-message-avatar--fallback {
  background: #f3f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-avatar.chat-message-avatar--assistant {
  background: #ed143d;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-avatar.chat-message-avatar--assistant ion-icon {
  font-size: 24px;
  color: #fff;
}

.message-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
  max-width: min(100%, 400px);
}

.message-row.user .message-content {
  align-items: flex-end;
}

.message-row.assistant .message-content {
  align-items: flex-start;
}

.message-timestamp {
  margin-top: 4px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 1.2;
  color: #5b5b5b;
}

.bubble {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.45;
  word-break: break-word;
}

.message-text {
  white-space: pre-wrap;
}

.message-text--segmented {
  display: inline;
  white-space: pre-wrap;
}

.message-text-part {
  white-space: pre-wrap;
}

.message-mention-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  vertical-align: middle;
  margin: 1px 2px;
  padding: 1px 7px 1px 5px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  max-width: min(160px, 100%);
  overflow: hidden;
  min-width: 0;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #5f5f5f;
}
.message-mention-chip ion-icon {
  font-size: 13px;
  flex-shrink: 0;
  color: #757575;
}
.message-mention-chip .message-mention-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.message-mention-chip--resource ion-icon {
  color: #1976d2;
}

/* Classic AI thinking shimmer (ChatGPT / shadcn-style) + soft fade */
.thinking-text {
  display: inline-block;
  background: linear-gradient(90deg, #8a8a8a 0%, #8a8a8a 35%, #222 50%, #8a8a8a 65%, #8a8a8a 100%);
  background-size: 200% auto;
  background-position: 200% center;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: thinkingShimmer 2s linear infinite, thinkingFade 2s ease-in-out infinite;
}

@keyframes thinkingShimmer {
  to {
    background-position: -200% center;
  }
}
@keyframes thinkingFade {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .thinking-text {
    animation: none;
    -webkit-text-fill-color: #666;
    color: #666;
    background: none;
  }
}
.approval-card {
  margin-top: 6px;
  padding: 10px 10px 8px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-left: 3px solid #ed143d;
}

.approval-card__header {
  margin-bottom: 8px;
}

.approval-card__eyebrow {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ed143d;
}

.approval-card__rows {
  list-style: none;
  margin: 0 0 8px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.approval-card__row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}
.approval-card__row ion-icon {
  margin-top: 1px;
  flex-shrink: 0;
  font-size: 15px;
  color: #ed143d;
}

.approval-card__row-text {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.approval-card__label {
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #9a9a9a;
}

.approval-card__value {
  margin-top: 1px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  color: #222;
  word-break: break-word;
}

.approval-card__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  margin: 0 -4px;
}
.approval-card__actions ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
  margin: 0;
  height: 30px;
  font-size: 12px;
}

.approval-card__confirm {
  --background: #ed143d;
  --background-activated: #d01236;
  --background-focused: #ed143d;
  --background-hover: #ed143d;
  --color: #fff;
  --border-radius: 6px;
}

.approval-status {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
}
.approval-status.denied {
  color: #ed143d;
}
.approval-status.editing {
  color: #1565c0;
}

.event-detail-scroll {
  max-height: 600px;
  overflow-y: auto;
  margin-top: 6px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
}
.event-detail-scroll app-view-edit-booking {
  display: block;
}

.error-banner {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fdecef;
  color: #ed143d;
  font-size: 13px;
}

ion-footer.chat-footer-host {
  position: relative;
  flex-shrink: 0;
  box-shadow: none;
  border-top: 1px solid #e8e8e8;
  background: #fff;
}

/*
 * ion-footer.footer-toolbar-padding sets safe-area on the last toolbar.
 * Do not override --padding-bottom or that safe-area padding is lost.
 */
.chat-footer-toolbar {
  --background: #fff;
  --border-width: 0;
  --min-height: 0;
  --padding-top: 6px;
  --padding-start: 8px;
  --padding-end: 8px;
}
.chat-footer-toolbar .input-row {
  width: 100%;
  padding-bottom: 6px;
}

.chat-input-info {
  margin: 0;
  padding: 8px 12px 0;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #5b5b5b;
  font-size: 10px;
  line-height: 1.35;
}
.chat-input-info ion-icon {
  margin-top: 1px;
  font-size: 14px;
  color: #7a7a7a;
  flex-shrink: 0;
}
.chat-input-info--listening {
  color: #ed143d;
  gap: 8px;
  padding-top: 10px;
  font-size: 10px;
  line-height: 1.2;
}
.chat-input-info--listening ion-icon {
  color: #ed143d;
  margin-top: 0;
  font-size: 18px;
}

.listening-label {
  font-size: 14px;
  letter-spacing: 0.01em;
}

.listening-dots {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 7px;
  height: 8px;
  margin-left: 1px;
}
.listening-dots span {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
  transform-origin: center;
  animation: listening-dot-wave 1s ease-in-out infinite;
}
.listening-dots span:nth-child(1) {
  animation-delay: 0s;
}
.listening-dots span:nth-child(2) {
  animation-delay: 0.12s;
}
.listening-dots span:nth-child(3) {
  animation-delay: 0.24s;
}
.listening-dots span:nth-child(4) {
  animation-delay: 0.36s;
}

@keyframes listening-dot-wave {
  0%, 100% {
    transform: scale(0.7) translateY(0);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.25) translateY(-1px);
    opacity: 1;
  }
}
.mention-popover {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 100%;
  margin-bottom: 6px;
  max-height: 190px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 20;
}

.mention-item {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.mention-item:not(:last-child) {
  border-bottom: 1px solid #f2f2f2;
}
.mention-item:hover {
  background: #faf6f8;
}

.mention-item-icon {
  flex-shrink: 0;
  font-size: 20px;
  color: #ed143d;
}

.mention-item-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.mention-name {
  color: #2b2b2b;
  font-size: 13px;
  font-weight: 600;
}

.mention-upn {
  color: #7a7a7a;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input-row {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}
.input-row ion-button {
  --color: #ed143d;
  --color-activated: #ed143d;
  --color-focused: #ed143d;
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0;
  height: 40px;
}
.input-row ion-button.mic-button ion-icon {
  font-size: 24px;
}
.input-row ion-button.button-disabled, .input-row ion-button[disabled] {
  opacity: 1;
}
.input-row ion-button.button-disabled::part(native), .input-row ion-button[disabled]::part(native) {
  opacity: 1;
}
.input-row .mic-button.is-listening {
  animation: mic-pulse 1.2s ease-in-out infinite;
}

@keyframes mic-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}
@media (prefers-reduced-motion: reduce) {
  .listening-dots span,
  .input-row .mic-button.is-listening {
    animation: none;
  }
  .listening-dots span {
    opacity: 1;
    transform: none;
  }
}
.compose-editor {
  flex: 1;
  min-height: 40px;
  max-height: 120px;
  overflow-y: auto;
  padding: 10px 12px;
  background: #f5f5f5;
  border-radius: 20px;
  font-size: 12px;
  line-height: 1.45;
  outline: none;
  word-wrap: break-word;
  white-space: pre-wrap;
  /* :empty alone fails after delete — browsers leave <br>/empty nodes */
}
.compose-editor.is-placeholder::before, .compose-editor:empty::before {
  content: attr(aria-placeholder);
  color: #999;
  pointer-events: none;
}
.compose-editor[contenteditable=false] {
  opacity: 0.6;
  pointer-events: none;
}

:host ::ng-deep .compose-editor .input-mention-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  vertical-align: middle;
  margin: 0 1px;
  padding: 1px 7px 1px 5px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  max-width: min(160px, 100%);
  overflow: hidden;
  min-width: 0;
}
:host ::ng-deep .compose-editor .input-mention-chip ion-icon {
  font-size: 13px;
  flex-shrink: 0;
}
:host ::ng-deep .compose-editor .input-mention-chip .input-mention-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

:host ::ng-deep .compose-editor .input-mention-chip--attendee {
  background: rgba(237, 20, 61, 0.12);
  border: 1px solid rgba(237, 20, 61, 0.28);
  color: #b81235;
}
:host ::ng-deep .compose-editor .input-mention-chip--attendee ion-icon {
  color: #ed143d;
}

:host ::ng-deep .compose-editor .input-mention-chip--resource {
  background: rgba(25, 118, 210, 0.1);
  border: 1px solid rgba(25, 118, 210, 0.24);
  color: #1565c0;
}
:host ::ng-deep .compose-editor .input-mention-chip--resource ion-icon {
  color: #1976d2;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ai-chat/ai-chat.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,kDAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EACE,eAAA;EACA,WAAA;AAEJ;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,wBAAA;UAAA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sFACE;AADJ;AAKE;EACE,mBAAA;EACA,qBAAA;EACA,sBAAA;AAHJ;;AAOA;EACE;IACE,UAAA;IACA,0BAAA;EAJF;EAMA;IACE,UAAA;IACA,wBAAA;EAJF;AACF;AAOA;EACE;IACE,eAAA;EALF;AACF;AAQA;EACE,aAAA;EACA,mBAAA;AANF;AAQE;EACE,yBAAA;AANJ;AAQI;EACE,mBAAA;EACA,YAAA;EACA,iCAAA;AANN;AAUE;EACE,2BAAA;AARJ;AAUI;EACE,mBAAA;EACA,WAAA;EACA,iCAAA;AARN;AAUM;EACE,gBAAA;AARR;AAWM;EACE,aAAA;AATR;AAaI;EACE,aAAA;AAXN;;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF;;AAgBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAbF;AAeE;EACE,iBAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAdJ;;AAkBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfF;AAiBE;EACE,eAAA;EACA,WAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,qBAAA;AAhBF;;AAmBA;EACE,uBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,qBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,qBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,2CAAA;EACA,cAAA;AAhBF;AAkBE;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAjBJ;;AAsBE;EACE,cAAA;AAnBJ;;AAuBA,qEAAA;AACA;EACE,qBAAA;EACA,gGAAA;EAQA,0BAAA;EACA,gCAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mFACE;AA5BJ;;AAgCA;EACE;IACE,iCAAA;EA7BF;AACF;AAgCA;EACE;IAEE,YAAA;EA/BF;EAiCA;IACE,UAAA;EA/BF;AACF;AAkCA;EACE;IACE,eAAA;IACA,6BAAA;IACA,WAAA;IACA,gBAAA;EAhCF;AACF;AAmCA;EACE,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAjCF;AAmCE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAjCJ;;AAqCA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,YAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAlCF;AAoCE;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAlCJ;;AAsCA;EACE,qBAAA;EACA,+BAAA;EACA,6BAAA;EACA,2BAAA;EACA,aAAA;EACA,oBAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAnCF;AAqCE;EACE,cAAA;AAnCJ;AAsCE;EACE,cAAA;AApCJ;;AAwCA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iCAAA;AArCF;AAuCE;EACE,cAAA;AArCJ;;AAyCA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAtCF;;AAyCA;;;EAAA;AAIA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;AAtCF;AAwCE;EACE,WAAA;EACA,mBAAA;AAtCJ;;AA0CA;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAvCF;AAyCE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAvCJ;AA0CE;EACE,cAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EAEA,gBAAA;AAzCJ;AA2CI;EACE,cAAA;EACA,aAAA;EACA,eAAA;AAzCN;;AA8CA;EACE,eAAA;EAEA,sBAAA;AA5CF;;AA+CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AA5CF;AA8CE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qDAAA;AA5CJ;AA8CI;EACE,mBAAA;AA5CN;AA8CI;EACE,sBAAA;AA5CN;AA8CI;EACE,sBAAA;AA5CN;AA8CI;EACE,sBAAA;AA5CN;;AAiDA;EACE;IAEE,mCAAA;IACA,YAAA;EA/CF;EAiDA;IACE,uCAAA;IACA,UAAA;EA/CF;AACF;AAkDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,WAAA;AAhDF;;AAmDA;EACE,WAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAhDF;AAkDE;EACE,gCAAA;AAhDJ;AAmDE;EACE,mBAAA;AAjDJ;;AAqDA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAlDF;;AAqDA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAlDF;AAoDE;EACE,gBAAA;EACA,0BAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAlDJ;AAoDM;EACE,eAAA;AAlDR;AAqDI;EAEE,UAAA;AApDN;AAsDM;EACE,UAAA;AApDR;AAyDE;EACE,8CAAA;AAvDJ;;AA2DA;EACE;IAEE,mBAAA;EAzDF;EA2DA;IACE,sBAAA;EAzDF;AACF;AA4DA;EACE;;IAEE,eAAA;EA1DF;EA6DA;IACE,UAAA;IACA,eAAA;EA3DF;AACF;AA8DA;EACE,OAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,qBAAA;EAEA,sEAAA;AA7DF;AA8DE;EAEE,+BAAA;EACA,WAAA;EACA,oBAAA;AA7DJ;AAgEE;EACE,YAAA;EACA,oBAAA;AA9DJ;;AAkEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,aAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;AA/DF;AAiEE;EACE,eAAA;EACA,cAAA;AA/DJ;AAkEE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAhEJ;;AAoEA;EACE,mCAAA;EACA,yCAAA;EACA,cAAA;AAjEF;AAmEE;EACE,cAAA;AAjEJ;;AAqEA;EACE,mCAAA;EACA,0CAAA;EACA,cAAA;AAlEF;AAoEE;EACE,cAAA;AAlEJ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n  padding-bottom: var(--ai-chat-keyboard-inset, 0px);\n}\n\n.chat-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  --padding-start: 12px;\n  --padding-end: 12px;\n  --padding-top: 12px;\n  --padding-bottom: 12px;\n}\n\n.chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 12px;\n  animation: chatEmptyIn 0.4s ease-out;\n}\n\n.chat-empty__icon {\n  width: 56px;\n  height: 56px;\n  margin-bottom: 12px;\n  border-radius: 50%;\n  background: #ed143d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ion-icon {\n    font-size: 28px;\n    color: #fff;\n  }\n}\n\n.chat-empty__title {\n  margin: 0 0 8px;\n  font-size: 22px;\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: break-spaces;\n}\n\n.chat-empty__subtitle {\n  margin: 0 0 14px;\n  max-width: 300px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #666;\n}\n\n.chat-empty__hint {\n  max-width: 300px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #888;\n}\n\n.chat-empty__resume {\n  appearance: none;\n  margin-top: 16px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #ed143d;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n\n  &:active {\n    opacity: 0.75;\n  }\n}\n\n.chat-empty__suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-width: 320px;\n}\n\n.chat-empty__chip {\n  appearance: none;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e5e5e5;\n  border-radius: 12px;\n  background: #fff;\n  color: #333;\n  font: inherit;\n  font-size: 13px;\n  line-height: 1.35;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease,\n    transform 0.15s ease;\n\n  &:active {\n    background: #fafafa;\n    border-color: #ed143d;\n    transform: scale(0.99);\n  }\n}\n\n@keyframes chatEmptyIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .chat-empty {\n    animation: none;\n  }\n}\n\n.message-row {\n  display: flex;\n  margin-bottom: 10px;\n\n  &.user {\n    justify-content: flex-end;\n\n    .bubble {\n      background: #ed143d;\n      color: white;\n      border-radius: 16px 4px 16px 16px;\n    }\n  }\n\n  &.assistant {\n    justify-content: flex-start;\n\n    .bubble {\n      background: #f0f0f0;\n      color: #333;\n      border-radius: 4px 16px 16px 16px;\n\n      &:has(> *) {\n        min-height: 40px;\n      }\n\n      &:has(.chat-markdown) .thinking-text {\n        display: none;\n      }\n    }\n\n    &:not(:has(.bubble > *)) {\n      display: none;\n    }\n  }\n}\n\n.message-row-inner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  max-width: 88%;\n}\n\n.message-row.user .message-row-inner {\n  flex-direction: row-reverse;\n}\n\nion-avatar.chat-message-avatar {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n\n  img {\n    object-fit: cover;\n  }\n\n  span {\n    font-size: 11px;\n    font-weight: 700;\n    color: #ed143d;\n    letter-spacing: 0.02em;\n  }\n}\n\nion-avatar.chat-message-avatar--fallback {\n  background: #f3f3f3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-avatar.chat-message-avatar--assistant {\n  background: #ed143d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ion-icon {\n    font-size: 24px;\n    color: #fff;\n  }\n}\n\n.message-content {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1 1 auto;\n  max-width: min(100%, 400px);\n}\n\n.message-row.user .message-content {\n  align-items: flex-end;\n}\n\n.message-row.assistant .message-content {\n  align-items: flex-start;\n}\n\n.message-timestamp {\n  margin-top: 4px;\n  padding: 0 4px;\n  font-size: 10px;\n  line-height: 1.2;\n  color: #5b5b5b;\n}\n\n.bubble {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: 14px;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.message-text {\n  white-space: pre-wrap;\n}\n\n.message-text--segmented {\n  display: inline;\n  white-space: pre-wrap;\n}\n\n.message-text-part {\n  white-space: pre-wrap;\n}\n\n.message-mention-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  vertical-align: middle;\n  margin: 1px 2px;\n  padding: 1px 7px 1px 5px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.35;\n  max-width: min(160px, 100%);\n  overflow: hidden;\n  min-width: 0;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  color: #5f5f5f;\n\n  ion-icon {\n    font-size: 13px;\n    flex-shrink: 0;\n    color: #757575;\n  }\n\n  .message-mention-chip-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n  }\n}\n\n.message-mention-chip--resource {\n  ion-icon {\n    color: #1976d2;\n  }\n}\n\n/* Classic AI thinking shimmer (ChatGPT / shadcn-style) + soft fade */\n.thinking-text {\n  display: inline-block;\n  background: linear-gradient(\n    90deg,\n    #8a8a8a 0%,\n    #8a8a8a 35%,\n    #222 50%,\n    #8a8a8a 65%,\n    #8a8a8a 100%\n  );\n  background-size: 200% auto;\n  background-position: 200% center;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  animation:\n    thinkingShimmer 2s linear infinite,\n    thinkingFade 2s ease-in-out infinite;\n}\n\n@keyframes thinkingShimmer {\n  to {\n    background-position: -200% center;\n  }\n}\n\n@keyframes thinkingFade {\n  0%,\n  100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .thinking-text {\n    animation: none;\n    -webkit-text-fill-color: #666;\n    color: #666;\n    background: none;\n  }\n}\n\n.approval-card {\n  margin-top: 6px;\n  padding: 10px 10px 8px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #ebebeb;\n  border-left: 3px solid #ed143d;\n}\n\n.approval-card__header {\n  margin-bottom: 8px;\n}\n\n.approval-card__eyebrow {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #ed143d;\n}\n\n.approval-card__rows {\n  list-style: none;\n  margin: 0 0 8px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.approval-card__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n\n  ion-icon {\n    margin-top: 1px;\n    flex-shrink: 0;\n    font-size: 15px;\n    color: #ed143d;\n  }\n}\n\n.approval-card__row-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.approval-card__label {\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #9a9a9a;\n}\n\n.approval-card__value {\n  margin-top: 1px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #222;\n  word-break: break-word;\n}\n\n.approval-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n  margin: 0 -4px;\n\n  ion-button {\n    --padding-start: 8px;\n    --padding-end: 8px;\n    margin: 0;\n    height: 30px;\n    font-size: 12px;\n  }\n}\n\n.approval-card__confirm {\n  --background: #ed143d;\n  --background-activated: #d01236;\n  --background-focused: #ed143d;\n  --background-hover: #ed143d;\n  --color: #fff;\n  --border-radius: 6px;\n}\n\n.approval-status {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #666;\n\n  &.denied {\n    color: #ed143d;\n  }\n\n  &.editing {\n    color: #1565c0;\n  }\n}\n\n.event-detail-scroll {\n  max-height: 600px;\n  overflow-y: auto;\n  margin-top: 6px;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 10px;\n  -webkit-overflow-scrolling: touch;\n\n  app-view-edit-booking {\n    display: block;\n  }\n}\n\n.error-banner {\n  margin-top: 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #fdecef;\n  color: #ed143d;\n  font-size: 13px;\n}\n\nion-footer.chat-footer-host {\n  position: relative;\n  flex-shrink: 0;\n  box-shadow: none;\n  border-top: 1px solid #e8e8e8;\n  background: #fff;\n}\n\n/*\n * ion-footer.footer-toolbar-padding sets safe-area on the last toolbar.\n * Do not override --padding-bottom or that safe-area padding is lost.\n */\n.chat-footer-toolbar {\n  --background: #fff;\n  --border-width: 0;\n  --min-height: 0;\n  --padding-top: 6px;\n  --padding-start: 8px;\n  --padding-end: 8px;\n\n  .input-row {\n    width: 100%;\n    padding-bottom: 6px;\n  }\n}\n\n.chat-input-info {\n  margin: 0;\n  padding: 8px 12px 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #fff;\n  color: #5b5b5b;\n  font-size: 10px;\n  line-height: 1.35;\n\n  ion-icon {\n    margin-top: 1px;\n    font-size: 14px;\n    color: #7a7a7a;\n    flex-shrink: 0;\n  }\n\n  &--listening {\n    color: #ed143d;\n    gap: 8px;\n    padding-top: 10px;\n    font-size: 10px;\n    // font-weight: 600;\n    line-height: 1.2;\n\n    ion-icon {\n      color: #ed143d;\n      margin-top: 0;\n      font-size: 18px;\n    }\n  }\n}\n\n.listening-label {\n  font-size: 14px;\n  // font-weight: 600;\n  letter-spacing: 0.01em;\n}\n\n.listening-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 7px;\n  height: 8px;\n  margin-left: 1px;\n\n  span {\n    width: 3px;\n    height: 3px;\n    border-radius: 50%;\n    background: currentColor;\n    transform-origin: center;\n    animation: listening-dot-wave 1s ease-in-out infinite;\n\n    &:nth-child(1) {\n      animation-delay: 0s;\n    }\n    &:nth-child(2) {\n      animation-delay: 0.12s;\n    }\n    &:nth-child(3) {\n      animation-delay: 0.24s;\n    }\n    &:nth-child(4) {\n      animation-delay: 0.36s;\n    }\n  }\n}\n\n@keyframes listening-dot-wave {\n  0%,\n  100% {\n    transform: scale(0.7) translateY(0);\n    opacity: 0.4;\n  }\n  50% {\n    transform: scale(1.25) translateY(-1px);\n    opacity: 1;\n  }\n}\n\n.mention-popover {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: 100%;\n  margin-bottom: 6px;\n  max-height: 190px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e4e4e4;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n}\n\n.mention-item {\n  width: 100%;\n  background: transparent;\n  border: 0;\n  text-align: left;\n  padding: 9px 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #f2f2f2;\n  }\n\n  &:hover {\n    background: #faf6f8;\n  }\n}\n\n.mention-item-icon {\n  flex-shrink: 0;\n  font-size: 20px;\n  color: #ed143d;\n}\n\n.mention-item-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.mention-name {\n  color: #2b2b2b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.mention-upn {\n  color: #7a7a7a;\n  font-size: 11px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.input-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n\n  ion-button {\n    --color: #ed143d;\n    --color-activated: #ed143d;\n    --color-focused: #ed143d;\n    --padding-start: 4px;\n    --padding-end: 4px;\n    margin: 0;\n    height: 40px;\n    &.mic-button {\n      ion-icon {\n        font-size: 24px;\n      }\n    }\n    &.button-disabled,\n    &[disabled] {\n      opacity: 1;\n\n      &::part(native) {\n        opacity: 1;\n      }\n    }\n  }\n\n  .mic-button.is-listening {\n    animation: mic-pulse 1.2s ease-in-out infinite;\n  }\n}\n\n@keyframes mic-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.08);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .listening-dots span,\n  .input-row .mic-button.is-listening {\n    animation: none;\n  }\n\n  .listening-dots span {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.compose-editor {\n  flex: 1;\n  min-height: 40px;\n  max-height: 120px;\n  overflow-y: auto;\n  padding: 10px 12px;\n  background: #f5f5f5;\n  border-radius: 20px;\n  font-size: 12px;\n  line-height: 1.45;\n  outline: none;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n\n  /* :empty alone fails after delete — browsers leave <br>/empty nodes */\n  &.is-placeholder::before,\n  &:empty::before {\n    content: attr(aria-placeholder);\n    color: #999;\n    pointer-events: none;\n  }\n\n  &[contenteditable='false'] {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n}\n\n:host ::ng-deep .compose-editor .input-mention-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  vertical-align: middle;\n  margin: 0 1px;\n  padding: 1px 7px 1px 5px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n  user-select: none;\n  white-space: nowrap;\n  max-width: min(160px, 100%);\n  overflow: hidden;\n  min-width: 0;\n\n  ion-icon {\n    font-size: 13px;\n    flex-shrink: 0;\n  }\n\n  .input-mention-chip-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n  }\n}\n\n:host ::ng-deep .compose-editor .input-mention-chip--attendee {\n  background: rgba(237, 20, 61, 0.12);\n  border: 1px solid rgba(237, 20, 61, 0.28);\n  color: #b81235;\n\n  ion-icon {\n    color: #ed143d;\n  }\n}\n\n:host ::ng-deep .compose-editor .input-mention-chip--resource {\n  background: rgba(25, 118, 210, 0.1);\n  border: 1px solid rgba(25, 118, 210, 0.24);\n  color: #1565c0;\n\n  ion-icon {\n    color: #1976d2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
